// extracted by mini-css-extract-plugin
export default {"progressive-image":"w_Oxf_","loaded":"_tjqcj"};